import {h, Fragment} from "preact"
import { usePagination, useActions } from '@nosto/preact'

function PageLink({ onClick, href, className, ariaLabel, children }) {
    return (
        <a href={href} aria-label={ariaLabel} onClick={onClick}>
            {children}
        </a>
    )
}

export default function Pagination() {
    const { prev, first, pages, last, next } = usePagination({
        width: 5,
    })

    const { updateSearch, simulateUpdateSearch } = useActions()

    function pageLinkProps({ from }) {
        return {
            onClick: (e) => {
                e.preventDefault()
                updateSearch({ products: { from } })
                scrollTo(0, 0)
            },
            href: simulateUpdateSearch({ products: { from } }).url,
        }
    }

    if (!pages || pages.length <= 1) {
        return null
    }

    return (
        <div class="pagination">
            {prev && (
                <span class="prev">
                    <PageLink {...pageLinkProps(prev)} ariaLabel="Previous page">
                        <svg
                            aria-hidden="true"
                            focusable="false"
                            role="presentation"
                            class="icon icon-chevron-left"
                            viewBox="0 0 284.49 498.98">
                            <path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path>
                        </svg>
                        <span class="icon__fallback-text">Edellinen</span>
                    </PageLink>
                </span>
            )}

            {first && (
                <>
                    <span class="page">
                        <PageLink {...pageLinkProps(first)} ariaLabel="First page">
                            {first.page}
                        </PageLink>
                    </span>
                    <span class="ns-py-2 ns-px-4">...</span>
                </>
            )}

            {pages.map((page) => (
                <span key={page.page} class={`page${page.current ? ' current' : ''}`}>
                    {page.current ? (
                        <span aria-current="page">{page.page}</span>
                    ) : (
                        <PageLink ariaLabel={`${page.page} page`} {...pageLinkProps(page)}>
                            {page.page}
                        </PageLink>
                    )}
                </span>
            ))}

            {last && (
                <>
                    <span class="ns-py-2 ns-px-4">...</span>
                    <span class="page">
                        <PageLink {...pageLinkProps(last)} ariaLabel="Last page">
                            {last.page}
                        </PageLink>
                    </span>
                </>
            )}

            {next && (
                <span class="next">
                    <PageLink {...pageLinkProps(next)} ariaLabel="Next page">
                        <svg
                            aria-hidden="true"
                            focusable="false"
                            role="presentation"
                            class="icon icon-chevron-right"
                            viewBox="0 0 284.49 498.98">
                            <path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path>
                        </svg>
                        <span class="icon__fallback-text">Seuraava</span>
                    </PageLink>
                </span>
            )}
        </div>
    )
}
